import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";

import { DropDownMultiCheck } from "../DropDownMultiCheck";
import IconDelete from "../../../../layout/others/icon-x.svg";

export default function Zones({ searchObject, setSearchObject, t }) {
  const [zones, setZones] = useState([]);

  useEffect(
    () => CommonService.getAllAddressZone().then((data) => setZones(data)),
    []
  );
  function setSelectedZones(list) {
    setSearchObject({ ...searchObject, zones: list });
  }

  function clearZones() {
    let _searchObject = { ...searchObject };
    _searchObject.zones = [];

    setSearchObject(_searchObject);
  }

  return (
    <div>
      <legend className="fontsize-legend">{t("Zone")}</legend>
      {searchObject.zones?.length !== 0 && (
        <button
          onClick={clearZones}
          className="btn-clear-language-level btn-mobile position-clear-button"
        >
          <img src={IconDelete} alt="ico-ppl" height="12px" width="auto" />
        </button>
      )}
      <DropDownMultiCheck
        dataList={zones}
        selecteds={searchObject.zones}
        setSelecteds={setSelectedZones}
      />
    </div>
  );
}
